/**
 * SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
 * Copyright (C) 2025 SuiteCRM Ltd.
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License version 3 as published by the
 * Free Software Foundation with the addition of the following permission added
 * to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
 * IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
 * WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 *
 * In accordance with Section 7(b) of the GNU Affero General Public License
 * version 3, these Appropriate Legal Notices must retain the display of the
 * "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
 * feasible for technical reasons, the Appropriate Legal Notices must display
 * the words "Supercharged by SuiteCRM".
 */

import {ObjectMap} from "../../common/types/object-map";
import {WritableSignal} from "@angular/core";
import {StringMap} from "../../common/types/string-map";
import {NgbModalOptions} from "@ng-bootstrap/ng-bootstrap/modal/modal-config";
import {Record} from "../../common/record/record.model";

export interface RecordModalOptions {
    titleKey?: string;
    record?: Record;
    dynamicTitleKey?: string;
    descriptionKey?: string;
    mapFields?: ObjectMap;
    labelKey?: string;
    headerLabelKey?: string;
    dynamicDescriptionKey?: string;
    module: string;
    detached?: boolean;
    minimizable?: boolean;
    bodyClass?: string;
    footerClass?: string;
    wrapperClass?: string;
    headerClass?: string;
    descriptionLabelKey?: string;
    dynamicTitleContext?: string;
    mode?: string;
    metadataView?: string;
    topButtonsDropdownLabelKey?: string;
    centered?: boolean;
    parentId?: string;
    backdrop?: boolean;
    dynamicDescriptionContext?: WritableSignal<StringMap>;
    parentModule?: string;
    scrollable?: boolean;
    size?: 'sm' | 'lg' | 'xl';
    modalOptions?: NgbModalOptions

    [key: string]: any;
}
